import BaseButton from '@Components/Form/BaseButton/BaseButton'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import clsx from 'clsx'
import { CommonService } from '@Services/common.service'
import { IPageHeaderActions } from '@Models/common.model'
import './PageHeader.scss'

// models section
interface IPageHeader {
    title: string
    actions?: IPageHeaderActions[]
    getActions?: (action?: string) => void
    total?: number
    textName?: string
}

function PageHeader(props: IPageHeader) {
    // core section
    const { title, actions, getActions, total, textName } = props

    // main
    return (
        <div className="page-header">
            <div className="title">
                {title}
                {total ? (
                    <span className="ml-1 d-inline-block fs-14 gray-text font-weight-normal">
                        | Total: {total}
                    </span>
                ) : null}
            </div>

            <div className="button-container">
                {actions?.length
                    ? actions?.map((action, index) => (
                          <BaseButton
                              key={`${action?.value}_header_action`}
                              onClick={() =>
                                  getActions && getActions(action?.value)
                              }
                              className={clsx(
                                  'variant-red page-header-btn',
                                  index !== 0 && 'ml-2',
                                  action?.className
                              )}
                              disabled={action?.disabled}
                              variant={action?.variant}
                              isLoading={action?.isLoading}
                          >
                              {action?.name}
                          </BaseButton>
                      ))
                    : ''}
                {textName && (
                    <>
                        <FiberManualRecordIcon
                            className="main-text"
                            style={{ fontSize: 8 }}
                        />{' '}
                        <span
                            style={{ fontSize: '12px' }}
                            className="text-capitalize"
                        >
                            {CommonService.textCapitalize(textName)}
                        </span>
                    </>
                )}
            </div>
        </div>
    )
}

export default PageHeader
